import { css } from '@emotion/react'
import { Button, Heading, HFlow, Icon, ModalCloseButton, VFlow } from 'bold-ui'
import { resolveName } from 'components/form'
import { RefObject } from 'react'
import { useField } from 'react-final-form'
import { MetaPath, MetaRoot } from 'util/metaPath'

import { getPerguntaAtivaInfo } from '../consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { CONSULTA_SEGUIMENTO_PERGUNTAS } from '../consultaSeguimentoPerguntasMap'
import {
  ConsultaSeguimentoAplicacaoModel,
  ConsultaSeguimentoFieldModel,
  MChatPerguntaPrincipal,
} from '../model-consultaSeguimento'

interface ConsultaSeguimentoModalTabAdicionarProps {
  path: MetaRoot<ConsultaSeguimentoFieldModel>
  containerRef: RefObject<HTMLDivElement>
  goNextButtonRef: RefObject<HTMLButtonElement>
  backToSelecaoButtonRef: RefObject<HTMLButtonElement>
  backQuestionButtonRef: RefObject<HTMLButtonElement>
  onGoBackToSelecao: () => void
  onGoToPreviousQuestion: () => void
}

export function ConsultaSeguimentoModalTabAdicionar(props: Readonly<ConsultaSeguimentoModalTabAdicionarProps>) {
  const {
    path,
    containerRef,
    goNextButtonRef,
    backToSelecaoButtonRef,
    backQuestionButtonRef,
    onGoBackToSelecao,
    onGoToPreviousQuestion,
  } = props

  const {
    input: { value: aplicacao },
  } = useField(resolveName(path.aplicacao), { subscription: { value: true } })

  const {
    input: { value: perguntasSelecionadas },
  } = useField(resolveName(path.perguntasSelecionadas), { subscription: { value: true } })

  const { perguntaAtiva, isFirst: isFirstPergunta } = getPerguntaAtivaInfo(aplicacao || {})

  return (
    <VFlow vSpacing={2}>
      <HFlow alignItems='flex-start' justifyContent='space-between'>
        {isFirstPergunta ? (
          <Button kind='normal' size='small' innerRef={backToSelecaoButtonRef} onClick={onGoBackToSelecao}>
            <Icon icon='arrowLeft' style={styles.backIcon} />
            Voltar à seleção
          </Button>
        ) : (
          <Button kind='normal' size='small' innerRef={backQuestionButtonRef} onClick={onGoToPreviousQuestion}>
            <Icon icon='arrowLeft' style={styles.backIcon} />
            Voltar
          </Button>
        )}
        <ModalCloseButton />
      </HFlow>
      <VFlow>
        <Heading level={1}>Entrevista de seguimento</Heading>
        {perguntaAtiva && renderField(perguntaAtiva, path, perguntasSelecionadas, goNextButtonRef, containerRef)}
      </VFlow>
    </VFlow>
  )
}

const styles = {
  backIcon: css`
    margin-right: 0.5rem;
  `,
}

function renderField<Key extends MChatPerguntaPrincipal>(
  key: Key,
  path: MetaRoot<ConsultaSeguimentoFieldModel>,
  perguntasSelecionadas: MChatPerguntaPrincipal[],
  goNextButtonRef: RefObject<HTMLButtonElement>,
  containerRef: RefObject<HTMLDivElement>
) {
  const { Field } = CONSULTA_SEGUIMENTO_PERGUNTAS[key]

  return (
    <Field
      name={path.aplicacao[key] as MetaPath<NonNullable<ConsultaSeguimentoAplicacaoModel[Key]>>}
      perguntasSelecionadas={perguntasSelecionadas}
      goNextButtonRef={goNextButtonRef}
      containerRef={containerRef}
    />
  )
}
